var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 16.0887C12.7907 16.0887 15.999 12.8602 15.999 8.87766C15.999 4.89512 12.7907 1.66663 8.83301 1.66663C4.87533 1.66663 1.66699 4.89512 1.66699 8.87766C1.66699 12.8602 4.87533 16.0887 8.83301 16.0887Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.2288 18.296C16.9504 18.287 16.6857 18.1725 16.4877 17.9754L14.7907 15.9918C14.4269 15.6591 14.3971 15.0936 14.724 14.7241C14.877 14.5692 15.085 14.4822 15.302 14.4822C15.519 14.4822 15.727 14.5692 15.8801 14.7241L18.0143 16.4317C18.3217 16.7464 18.4166 17.2135 18.2565 17.6243C18.0964 18.0351 17.7113 18.3128 17.2732 18.3333L17.2288 18.296Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3f68714616a3993e849415989a564cab.svg";
export { ForwardRef as ReactComponent };